import React, { useState } from 'react';
import '../Contact.css';

function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus(null);
    fetch('https://api.virajpargaonkar.me/api/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, message }),
    })
      .then((res) => {
        if (!res.ok) throw new Error();
        setStatus('success');
        setName(''); setEmail(''); setMessage('');
      })
      .catch(() => setStatus('error'));
  };

  return (
    <>
      <section className="page-banner">
        <div className="container">
          <h1 className="Banner-title">contact<span className="Banner-dot">.</span></h1>
          <p className="Banner-sub">
            Get in touch with me via social media or send me an email.
          </p>
        </div>
      </section>

      <main className="page-content">
        <div className="container">

          {/* Social icons row */}
          <ul className="social-list" data-aos="fade-up">
            {/* GitHub */}
            <li className="social-item">
              <a
                href="https://github.com/virajnp"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
                className="social-link"
              >
                <span className="icon-circle gh">
                  <svg width="28" height="28" viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M12 2C6.48 2 2 6.58 2 12.26c0 4.52 2.87 8.35 6.84 9.7c.5.1.68-.22.68-.49
                      c0-.24-.01-.87-.01-1.71c-2.78.62-3.37-1.37-3.37-1.37c-.45-1.18-1.11-1.49-1.11-1.49c-.91-.64.07-.63.07-.63
                      c1 .07 1.53 1.05 1.53 1.05c.9 1.58 2.36 1.12 2.94.86c.09-.67.35-1.12.63-1.38c-2.22-.26-4.56-1.14-4.56-5.09
                      c0-1.12.39-2.04 1.03-2.76c-.1-.26-.45-1.31.1-2.73c0 0 .84-.27 2.75 1.05a9.3 9.3 0 0 1 2.5-.34
                      c.85 0 1.71.11 2.5.34c1.91-1.32 2.75-1.05 2.75-1.05c.55 1.42.2 2.47.1 2.73c.64.72 1.03 1.64 1.03 2.76
                      c0 3.96-2.34 4.82-4.57 5.08c.36.32.68.95.68 1.92c0 1.39-.01 2.51-.01 2.85c0 .27.18.6.69.49
                      C19.13 20.61 22 16.78 22 12.26C22 6.58 17.52 2 12 2Z" />
                  </svg>
                </span>
                <span className="social-label">GitHub</span>
              </a>
            </li>
            
            {/* LinkedIn (inline SVG, no font dependency) */}
            <li className="social-item">
              <a
              href="https://www.linkedin.com/in/virajpargaonkar"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="social-link"
              >
                <span className="icon-circle li">
      {/* Font Awesome “linkedin-in” path as inline SVG */}
                  <svg
                  width="28"
                  height="28"
                  viewBox="0 0 448 512"
                  aria-hidden="true"
                  focusable="false"
                  >
                    <path
                    fill="currentColor"
                    d="M100.28 448H7.4V148.9h92.88zM53.84 109a53.79 53.79 0 1 1 53.79-53.79A53.79 53.79 0 0 1 53.84 109zM447.9 448h-92.4V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.6V448h-92.5V148.9h88.8v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"
                    />
                  </svg>
                </span>
                <span className="social-label">LinkedIn</span>
              </a>
            </li>

            {/* X (Twitter) */}
            <li className="social-item">
              <a
                href="https://x.com/virajnp"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X"
                className="social-link"
              >
                <span className="icon-circle x">
                  <svg width="28" height="28" viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M18.244 3H21l-6.58 7.51L22 21h-5.828l-4.57-5.527L6.4 21H3.64l7.02-8.01L3 3h5.953l4.11 5.02L18.244 3Zm-2.04 16.17h1.52L8.88 4.75H7.26l8.944 14.42Z" />
                  </svg>
                </span>
                <span className="social-label">X</span>
              </a>
            </li>
          </ul>

          {/* Contact details */}
          <div className="contact-details" data-aos="fade-up">
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <span>San&nbsp;Jose, CA, USA</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <span>
                <a href="mailto:virajnp@gmail.com">virajnp@gmail.com</a>
              </span>
            </div>
          </div>

          {/* Contact form */}
          <form className="contact-form" onSubmit={handleSubmit} data-aos="fade-up">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                rows="4"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn">Send Message</button>

            {status === 'success' && (
              <p className="form-status success">Thank you! Your message has been sent.</p>
            )}
            {status === 'error' && (
              <p className="form-status error">Sorry, there was a problem sending your message.</p>
            )}
          </form>
        </div>
      </main>
    </>
  );
}

export default Contact;
